/**
 * Feature switches in the screens (D14): whether this organisation has a
 * feature. Everything that belongs to a feature that is off is hidden — its
 * screen from the menu, its tile on the dashboard, its tab, its button — and
 * the API refuses it besides, so a hidden control is never the only fence.
 */

import type { FeatureId } from "@baros/core";
import type { Me } from "./api.js";

/**
 * Whether `me`'s organisation has `feature`. False until `/v1/me` has
 * answered, so nothing gated shows during the load or after it fails. An API
 * from before the switches sends no list, and everything was on then.
 */
export function hasFeature(me: Pick<Me, "features"> | null | undefined, feature: FeatureId): boolean {
  if (!me) return false;
  return !me.features || me.features.includes(feature);
}
